'use client'

import { HEADER_HEIGHT_PX, HEADER_HEIGHT } from '@/constants/layout'
import { useWishlistStore } from '@/store'
import FavoriteBorderIcon from '@mui/icons-material/FavoriteBorder'
import HomeIcon from '@mui/icons-material/Home'
import PersonIcon from '@mui/icons-material/Person'
import { Badge, BottomNavigation, BottomNavigationAction, Paper, useTheme } from '@mui/material'
import { useTranslations } from 'next-intl'
import CampaignIcon from '@mui/icons-material/Campaign'
import { useRouter } from '@/libs/i18n/routing'
import { useState, useEffect } from 'react'
import { usePathname } from 'next/navigation'

type ValidPath = '/' | '/blog' | '/accounts/wishlist' | '/profile'

export const NavbarBottom = () => {
  const value = usePathname()
  const router = useRouter()
  const theme = useTheme()
  const { wishlistItems } = useWishlistStore()
  const t = useTranslations()
  const [isVisible, setIsVisible] = useState(true)
  const [lastScrollY, setLastScrollY] = useState(0)

  useEffect(() => {
    // Set CSS variable cho bottom nav height
    const updateBottomNavHeight = (visible: boolean) => {
      const root = document.documentElement
      if (visible) {
        root.style.setProperty('--bottom-nav-height-xs', `${HEADER_HEIGHT.BOTTOM_NAV.xs}px`)
        root.style.setProperty('--bottom-nav-height-sm', `${HEADER_HEIGHT.BOTTOM_NAV.sm}px`)
      } else {
        root.style.setProperty('--bottom-nav-height-xs', '0px')
        root.style.setProperty('--bottom-nav-height-sm', '0px')
      }
    }

    const handleScroll = () => {
      const currentScrollY = window.scrollY
      const body = document.body
      // Chỉ ẩn/hiện khi scroll > 100px để tránh flickering
      if (currentScrollY > 100) {
        if (currentScrollY < lastScrollY) {
          body.classList.add('show-bottom-nav')
          // Scroll lên
          setIsVisible(true)
          updateBottomNavHeight(true)
        } else {
          body.classList.remove('show-bottom-nav')
          // Scroll xuống
          setIsVisible(false)
          updateBottomNavHeight(false)
        }
      } else {
        body.classList.remove('show-bottom-nav')
        // Luôn hiện khi ở gần đầu trang
        setIsVisible(true)
        updateBottomNavHeight(true)
      }

      setLastScrollY(currentScrollY)
    }

    // Set initial value
    updateBottomNavHeight(isVisible)

    // window.addEventListener('scroll', handleScroll, { passive: true })

    // return () => {
    //   window.removeEventListener('scroll', handleScroll)
    // }
  }, [lastScrollY, isVisible])

  const listItems: Array<{ value: ValidPath; label: string; icon: React.ReactNode }> = [
    {
      value: '/',
      label: t('Breadcrumb.home'),
      icon: <HomeIcon fontSize="small" />,
    },
    {
      value: '/blog',
      label: t('Breadcrumb.activities'),
      icon: <CampaignIcon fontSize="small" />,
    },
    {
      value: '/accounts/wishlist',
      label: t('Yêu thích'),
      icon: (
        <Badge badgeContent={wishlistItems?.items?.length ?? 0} color="primary">
          <FavoriteBorderIcon fontSize="small" />
        </Badge>
      ),
    },
    {
      value: '/profile',
      label: t('UserProfile.profile'),
      icon: <PersonIcon fontSize="small" />,
    },
  ]
  const handleNavigation = (newValue: ValidPath) => {
    if (newValue === value) {
      window.scrollTo({ top: 0, behavior: 'smooth' })
    } else {
      router.push(newValue as any)
    }
  }

  return (
    <Paper
      sx={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: theme.zIndex.appBar,
        display: { xs: 'block', md: 'none' },
        height: isVisible ? HEADER_HEIGHT_PX.BOTTOM_NAV : 0,
        transform: isVisible ? 'translateY(0)' : 'translateY(100%)',
        transition: 'transform 0.3s ease-in-out, height 0.3s ease-in-out',
        overflow: 'hidden',
      }}
      elevation={3}
    >
      <BottomNavigation
        showLabels
        value={value}
        onChange={(_, newValue) => {
          handleNavigation(newValue)
        }}
        sx={{
          backgroundColor: theme.palette.background.paper,
          borderTop: `1px solid ${theme.palette.divider}`,
          height: HEADER_HEIGHT_PX.BOTTOM_NAV,
        }}
      >
        {listItems.map((item, index) => (
          <BottomNavigationAction
            key={index}
            value={item.value}
            label={item.label}
            icon={item.icon}
            sx={{ minWidth: 'auto' }}
          />
        ))}
      </BottomNavigation>
    </Paper>
  )
}
